var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6889 2.4903C17.4667 1.81426 16.8444 1.33301 16.1111 1.33301H3.88889C3.15556 1.33301 2.54444 1.81426 2.31111 2.4903L0 9.35384V18.5205C0 19.1507 0.5 19.6663 1.11111 19.6663H2.22222C2.83333 19.6663 3.33333 19.1507 3.33333 18.5205V17.3747H16.6667V18.5205C16.6667 19.1507 17.1667 19.6663 17.7778 19.6663H18.8889C19.5 19.6663 20 19.1507 20 18.5205V9.35384L17.6889 2.4903ZM3.88889 13.9372C2.96667 13.9372 2.22222 13.1695 2.22222 12.2184C2.22222 11.2674 2.96667 10.4997 3.88889 10.4997C4.81111 10.4997 5.55556 11.2674 5.55556 12.2184C5.55556 13.1695 4.81111 13.9372 3.88889 13.9372ZM16.1111 13.9372C15.1889 13.9372 14.4444 13.1695 14.4444 12.2184C14.4444 11.2674 15.1889 10.4997 16.1111 10.4997C17.0333 10.4997 17.7778 11.2674 17.7778 12.2184C17.7778 13.1695 17.0333 13.9372 16.1111 13.9372ZM2.22222 8.20801L3.88889 3.05176H16.1111L17.7778 8.20801H2.22222Z",
    fill: "#183059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/Vehicle.fc2e60f7e52bd17b0792134b6232aef2.svg";
export { ForwardRef as ReactComponent };